module.exports = __webpack_public_path__ + "static/media/logo-skrill.dfdd83dc.svg";